import Ajax from '../../../../util/ajax';
export function zigbeeRemoveGroup(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/4/command/remove-group';
        const value = {
            'group id': payload.groupId
        };
        ajax.post(url, value);
    };
}
